<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>

        <v-flex xs12 md5>
          <v-text-field
            label="Nome"
            v-model="resource.name"
            :counter="100"
            required
            :error-messages="validationErrors.name">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field
            v-model="resource.cnpj"
            required
            v-mask="'##.###.###/####-##'"
            :error-messages="validationErrors.cnpj"
            label="CNPJ"></v-text-field>
        </v-flex>

      </v-layout>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'client-form',
  mixins: [CrudMixin],
  methods: {
    initCrud() {
      this.serviceType = ClientService;
      this.routerName = 'client';
      this.componentType = 'FORM';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/client/ClientForm.vue